<script setup>
import logo from "../assets/images/logo_purple.png"
const year = new Date().getFullYear()
</script>

<template>

  <div class="container">

    <div class="logo-container fade-in">
      <img :src="logo" alt="Black Paladins Logo" class="logo">
    </div>

    <h1 id="project-name" class="title fade-in">
      BLACK PALADINS
    </h1>

    <p id="project-description" class="description fade-in">
      Estúdio indie de desenvolvimento de jogos. Criando experiências únicas e memoráveis.
    </p>

    <div class="links">

      <a id="website-link" href="/" class="link-button slide-up">
        <span>SITE OFICIAL</span>
      </a>

      <a
        id="whatsapp-link"
        href="https://wa.me/5583991215097"
        target="_blank"
        rel="noopener noreferrer"
        class="link-button slide-up"
      >
        <span>WHATSAPP</span>
      </a>

      <div class="divider slide-up">

        <div class="line"></div>

        <span class="divider-text">
          CONTATOS
        </span>

        <div class="line"></div>

      </div>

      <a href="mailto:blackpaladinsgames@gmail.com" target="_blank" class="link-button slide-up">
        <div class="contact">
          <span class="contact-name">BLACK PALADINS</span>
          <span class="contact-email">blackpaladinsgames@gmail.com</span>
        </div>
      </a>

      <a href="mailto:jerffesonj@gmail.com" target="_blank" class="link-button slide-up">
        <div class="contact">
          <span class="contact-name">JÉRFFESON ARAÚJO</span>
          <span class="contact-email">Developer • jerffesonj@gmail.com</span>
        </div>
      </a>

      <a href="mailto:robson.robh@gmail.com" target="_blank" class="link-button slide-up">
        <div class="contact">
          <span class="contact-name">ROBSON SANTOS</span>
          <span class="contact-email">Artista • robson.robh@gmail.com</span>
        </div>
      </a>

    </div>

    <footer class="footer fade-in">
      <p class="footer-text">
        © {{ year }} BLACK PALADINS
      </p>
    </footer>

  </div>

</template>

<style scoped>
.container {
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 16px;
}

.logo-container {
  position: relative;
}

.logo {
  width: 50px;
  display: block;
  margin: 40px auto 10px auto;
}

.logo-container::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 20px;
  background: radial-gradient(ellipse, var(--card-sombra) 0%, transparent 70%);
  filter: blur(8px);
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin: 0 auto 10px auto;
  letter-spacing: 2px;
  text-shadow: 0 2px 20px var(--card-sombra);
}

.description {
  font-size: 14px;
  max-width: 350px;
  text-align: center;
  margin-bottom: 40px;
  letter-spacing: 1px;
  color: var(--cor-texto-secundario);
}

.links {
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.link-button {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 350px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border-radius: 12px;
  text-decoration: none;
  transition: all .3s;
  color: var(--cor-texto-principal);
  background: linear-gradient(135deg, var(--card-base), var(--card-secundaria));
  border: 1px solid var(--card-destaque);
  box-shadow: 0 4px 20px var(--card-sombra), inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.link-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left .5s ease;
}

.link-button:hover::before {
  left: 100%;
}

.link-button:hover {
  transform: translateY(-3px);
  background: linear-gradient(135deg, var(--card-secundaria), var(--card-destaque));
  box-shadow: 0 8px 30px var(--card-sombra), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

.divider {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
}

.line {
  flex: 1;
  height: 1px;
  width: 150px;
  background: linear-gradient(90deg, transparent, var(--cor-texto-suave), transparent);
}

.divider-text {
  font-size: 14px;
  letter-spacing: 2px;
  color: var(--cor-texto-suave);
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-name {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
}

.contact-email {
  font-size: 12px;
  color: var(--cor-texto-secundario);
}

.footer {
  margin-top: 40px;
  text-align: center;
}

.footer-text {
  font-size: 14px;
  color: var(--cor-texto-suave);
}

.fade-in {
  opacity: 0;
  animation: fadeIn .6s ease-out forwards;
}

.slide-up {
  opacity: 0;
  transform: translateY(20px);
  animation: slideUp .5s ease-out forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>